var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from "react";
import { PROBE_CATEGORY_ACTION_MAPPING, MetricType, PROBE_CATEGORY_METRIC_MAPPING } from "../../../../../models";
import { ProbeCategory, ProbeAction } from "../../../../../graphql";
export var useSteadyState = function (initialSteadyState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = __read(useState(initialSteadyState), 2), steadyState = _k[0], setSteadyState = _k[1];
    useEffect(function () {
        setSteadyState(initialSteadyState);
    }, [initialSteadyState]);
    var setProbeCategory = function (probeCategory) {
        setSteadyState({ probeCategory: probeCategory });
    };
    var setProbeAction = function (probeAction) {
        setSteadyState(function (prevSteadyState) { return ({
            probeCategory: prevSteadyState.probeCategory,
            probeAction: probeAction
        }); });
    };
    function setParameter(name) {
        return function (value) {
            setSteadyState(function (prevSteadyState) {
                var _a;
                return (__assign(__assign({}, prevSteadyState), { parameters: __assign(__assign({}, prevSteadyState.parameters), (_a = {}, _a[name] = value, _a)) }));
            });
        };
    }
    var fields = [
        {
            type: "text-select",
            name: "probeCategory",
            options: Object.values(ProbeCategory),
            label: "Probe Category",
            labelHelperText: "List of steady-state providers. We currently support signalfx and cloudwatch.",
            isRequired: true,
            value: steadyState.probeCategory,
            onChange: setProbeCategory
        },
        {
            type: "text-select",
            name: "probeAction",
            options: (_a = PROBE_CATEGORY_ACTION_MAPPING.get(steadyState.probeCategory)) !== null && _a !== void 0 ? _a : [],
            label: "Probe Action",
            labelHelperText: "Capabilities/Actions supported by the probe.",
            isRequired: true,
            value: steadyState.probeAction,
            onChange: setProbeAction
        }
    ];
    if (steadyState.probeAction) {
        if (steadyState.probeAction === ProbeAction.signalfx_query) {
            fields.push({
                type: "text-select",
                name: "parameters.metric_type",
                options: Object.values(MetricType),
                label: "Metric Type",
                labelHelperText: "The type of metric to be used in singalfx probe category. We support golden_metrics and custom signalfx_query.",
                isRequired: true,
                value: (_b = steadyState.parameters) === null || _b === void 0 ? void 0 : _b.metric_type,
                onChange: setParameter("metric_type")
            });
        }
        if (steadyState.probeAction === ProbeAction.alb_metrics ||
            (steadyState.probeAction === ProbeAction.signalfx_query &&
                ((_c = steadyState.parameters) === null || _c === void 0 ? void 0 : _c.metric_type) === MetricType.golden_metric)) {
            fields.push({
                type: "text-select",
                name: "parameters.probe_metric",
                options: (_d = PROBE_CATEGORY_METRIC_MAPPING.get(steadyState.probeCategory)) !== null && _d !== void 0 ? _d : [],
                label: "Probe Metric",
                isRequired: true,
                value: (_e = steadyState.parameters) === null || _e === void 0 ? void 0 : _e.probe_metric,
                onChange: setParameter("probe_metric")
            });
        }
        fields.push({
            type: "number",
            name: "parameters.probe_threshold",
            label: "Threshold",
            labelHelperText: "The steady-state threshold",
            isRequired: true,
            value: (_f = steadyState.parameters) === null || _f === void 0 ? void 0 : _f.probe_threshold,
            onChange: setParameter("probe_threshold")
        });
        fields.push({
            type: "radio",
            name: "parameters.operator_override",
            label: "Operator Override",
            labelHelperText: "The operator to be applied for the steady-state check",
            isRequired: true,
            value: (_g = steadyState.parameters) === null || _g === void 0 ? void 0 : _g.operator_override,
            onChange: setParameter("operator_override"),
            options: [
                {
                    label: "Less: < threshold ",
                    value: "lt"
                },
                {
                    label: "Greater: > threshold",
                    value: "gt"
                },
                {
                    label: "Less/Equal: <= threshold",
                    value: "lte"
                },
                {
                    label: "Greater/Equal: >= threshold",
                    value: "gte"
                }
            ]
        });
        if (steadyState.probeAction === ProbeAction.signalfx_query &&
            ((_h = steadyState.parameters) === null || _h === void 0 ? void 0 : _h.metric_type) === MetricType.raw_sfx_query) {
            fields.push({
                type: "textarea",
                name: "parameters.probe_metric",
                label: "Raw SFX Query",
                isRequired: true,
                value: (_j = steadyState.parameters) === null || _j === void 0 ? void 0 : _j.probe_metric,
                onChange: setParameter("probe_metric"),
                placeholder: "data('cpu.utilization', filter=filter('micros_service_id', 'resilience-core') and filter('environment', 'ddev'), rollup='average', extrapolation='null').max().publish()",
                minimumRows: 3
            });
        }
    }
    return {
        steadyState: steadyState,
        fields: fields
    };
};
